import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../lib/utils";

export const Stepper = forwardRef<HTMLInputElement, Omit<HTMLAttributes<HTMLDivElement>, "onChange"> & {
  label: string;
  value: number;
  onValueChange: (value: number) => void;
  min: number;
  max: number;
  step?: number;
}>(({
  label,
  value,
  onValueChange,
  min,
  max,
  step = 1,
  className,
  ...props
}, ref) => {
  const setValue = (next: number) => onValueChange(Math.min(max, Math.max(min, next)));
  return (
    <div className={cn("sqk-stepper", className)} {...props}>
      <span className="sqk-stepper__label">{label}</span>
      <div className="sqk-stepper__controls">
        <button aria-label={`Decrease ${label}`} disabled={value <= min} onClick={() => setValue(value - step)} type="button">−</button>
        <input
          aria-label={label}
          inputMode="numeric"
          max={max}
          min={min}
          onChange={(event) => setValue(Number(event.currentTarget.value))}
          ref={ref}
          step={step}
          type="number"
          value={value}
        />
        <button aria-label={`Increase ${label}`} disabled={value >= max} onClick={() => setValue(value + step)} type="button">+</button>
      </div>
    </div>
  );
});
Stepper.displayName = "Stepper";
